import { IQuantitySelectorOption } from '.'

const isSampleOption = (option: IQuantitySelectorOption) => {
  if (!option?.displayLabel) {
    return false
  }

  return option?.displayLabel?.toLowerCase()?.includes('sample')
}

const getFirstQuantityOptionWithPrice = (
  options: IQuantitySelectorOption[]
) => {
  return (
    options
      ?.filter((option) => {
        const isSampleQty = isSampleOption(option)
        const price =
          typeof option?.price?.salePrice === 'number'
            ? option?.price?.salePrice
            : option?.price?.originalPrice

        return price > 0 && !isSampleQty
      })
      ?.sort((a, b) => {
        const priceA =
          typeof a?.price?.salePrice === 'number'
            ? a?.price?.salePrice
            : a?.price?.originalPrice
        const priceB =
          typeof b?.price?.salePrice === 'number'
            ? b?.price?.salePrice
            : b?.price?.originalPrice
        return priceA - priceB
      })?.[0] || null
  )
}

const getSavingPercentage = (
  option: IQuantitySelectorOption,
  firstOptionWithPrice: IQuantitySelectorOption
) => {
  const optionPrice =
    typeof option?.price?.salePrice === 'number'
      ? option?.price?.salePrice
      : option?.price?.originalPrice

  if (!optionPrice) return null

  if (isSampleOption(option)) return null

  const firstQuantityOptionPrice =
    typeof firstOptionWithPrice?.price?.salePrice === 'number'
      ? firstOptionWithPrice?.price?.salePrice
      : firstOptionWithPrice?.price?.originalPrice

  const optionPricePerUnit =
    optionPrice / Number(option.key.replaceAll(',', ''))
  const firstQuantityOptionPricePerUnit =
    firstQuantityOptionPrice /
    Number(firstOptionWithPrice.key.replaceAll(',', ''))

  return (
    Math.round(
      ((firstQuantityOptionPricePerUnit - optionPricePerUnit) /
        firstQuantityOptionPricePerUnit) *
        100
    ) || null
  )
}

export { isSampleOption, getFirstQuantityOptionWithPrice, getSavingPercentage }
